import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import process from "process";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const deleteCookie = async (name) => {
  document.cookie =
    name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; samesite=strict";
};
function setCookieSession(name, value) {
  document.cookie = `${name}=${value}; path=/; secure; samesite=strict`;
}
function ConnectBackend() {
  const query = useQuery();
  const code = query.get("code");
  useEffect(() => {
    const setAuthCode = async () => {
    try {
      if (code) {
        await deleteCookie("landingpageAccessToken");
        await deleteCookie("landingpageAuthCode");
        setCookieSession("landingpageAuthCode", code);
        if (window.name === "ekomi-connect") {
          window.close();
        }
      }
    } catch (error) {
      console.error("Failed to set auth code", error);
    }
  }
  setAuthCode();
  }, [code]);
  return <></>;
}

export default ConnectBackend;
